<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/G-IGBT/G-IGBT.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">GFM IGBT Power Modules</div>
                <div class="detail-banner-desc">The 7th generation micro-trench IGBT.</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            The 7th generation micro-trench IGBT.<br />
                        </div>
                        <div>
                            Efficient heat dissipation pin-fin, thermal resistance is 10% lower than similar.<br />
                        </div>
                        <div>
                            Wide power class, covering 70-200kW.<br />
                        </div>
                        <div>
                            Platform based, 550A~1000A rated current products.<br />
                        </div>
                        <div>
                            Applications: Vehicle inverter
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/G-IGBT/G-IGBT-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">750V/1200V</div>
                                    <div class="k">Rated voltage</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1.25V/1.5V</div>
                                    <div class="k">Vcesat</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">400V/800V</div>
                                    <div class="k">Application voltage</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">400-600Arms</div>
                                    <div class="k">Current capability</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'GFM IGBT Power Modules - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/G-IGBT.html'

};

import { createApp } from 'vue';
import App from './G-IGBT.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./G-IGBT.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
